import { jsx as o } from "react/jsx-runtime";

import { forwardRef as r } from "react";

import e from "../../MaskInput/index.js";

import t from "../hooks/useGlobals.js";

import s from "../hooks/useFieldSubscription.js";

const a = o => o.searchValue, m = r(((r, m) => {
    const {model: n, components: i} = t(), p = s(n, a);
    return o(e, {
        // This gets overwritten if Formik passes in an id
        id: n.ids.input,
        ...r,
        ref: m,
        mask: n.format.replace(/\w/g, "_"),
        placeholder: n.format.toUpperCase(),
        value: p,
        onChange: n.handlers.input,
        suffix: o(i.CalendarButton, {})
    });
}));

export { m as default };
//# sourceMappingURL=InputWrapper.js.map
